module.exports = __webpack_public_path__ + "static/media/bg.3cb00e7a.jpg";